import { ApplicantInformation } from '../../Models/ApplicantInformation';
import { DefaultJobAd, JobAd, mapJobAdModel2Dto } from '../../Models/JobAd';
import { JobAdGenerationError } from '../../Models/JobAdGenerationError';
import { DefaultJobDetails, JobDetails } from '../../Models/JobDetails';
import TestInfo from '../../Models/TestInfo';
import { mapJobDetailsModel2Dto } from '../../Steps/JobDetailsStep/JobDetailsStepUtils';
import { CreateAssessmentDTO } from '@/DTO/Assessments/CreateAssessmentDTO';
import { TestTypes } from '@/Models/Configuration';
import { ExperienceCriteria } from '@/Models/ExperienceCriteria';
import ProcessingState from '@/Models/ProcessingState';
import HttpErrorTypes from '@/Utils/HTTP/Errors/HttpErrorType';

export interface CreateRecruitmentContextState {
    recruitmentId: string;
    clientId: string;
    jobDetails: JobDetails;
    includedTests: TestTypes[];
    testInfos: TestInfo[];
    applicantInformation: Array<ApplicantInformation>;
    showErrorDialog?: JobAdGenerationError | undefined;
    testLanguage: string;

    regenerateAtStep2: boolean;
    jobAd: JobAd;
    processingState: ProcessingState;
    jobAdError?: HttpErrorTypes;

    regenerateExperienceCriteria: boolean;
    experienceCriteria: Array<ExperienceCriteria>;
    experienceCriteriaProcessingState: ProcessingState;
    experienceCriteriaError?: HttpErrorTypes;

    isJobAdPrefilled: boolean;
    isExperienceCriteriaPrefilled: boolean;
}

export const DefaultTestLanguageFirstOption = 'applicant';

export const DefaultCreateRecruitmentContextState: CreateRecruitmentContextState = {
    recruitmentId: '',
    clientId: '',
    jobDetails: DefaultJobDetails,
    jobAd: DefaultJobAd,
    applicantInformation: [],
    includedTests: [],
    testInfos: [],
    processingState: ProcessingState.Idle,
    regenerateAtStep2: false,
    regenerateExperienceCriteria: false,
    testLanguage: DefaultTestLanguageFirstOption,
    experienceCriteria: [],
    experienceCriteriaProcessingState: ProcessingState.Idle,
    isJobAdPrefilled: false,
    isExperienceCriteriaPrefilled: false,
};

export function mapCreateRecruitmentContextState2Dto(state: CreateRecruitmentContextState): CreateAssessmentDTO {
    const { jobDetails, jobAd, includedTests, applicantInformation } = state;
    return {
        jobDetails: mapJobDetailsModel2Dto(jobDetails),
        jobAd: mapJobAdModel2Dto(jobAd),
        includedTests,
        applicantInformation: applicantInformation.map(({ informationType, informationCategory }) => {
            return {
                informationType,
                informationCategory,
            };
        }),
        locale: state.testLanguage === 'applicant' ? null : state.testLanguage,
        experienceCriteria: state.experienceCriteria,
    };
}
